<template>
  <div>
    <slot name="header" />
    <div class="mb-5">
      <div v-if="isFetchingUserSkills" class="full-width">
        <v-skeleton-loader type="list-item" />
      </div>
      <div v-else>
        <v-chip
          class="mr-2"
          v-for="(skill, index) in currentUserSkills"
          :key="index"
        >
          {{ skill.level }} {{ skill.name }}
        </v-chip>
        <span v-if="isListEmpty"> - </span>
      </div>
    </div>
    <v-divider v-if="showDivider" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { FETCH_USER_SKILLS } from "@/store/modules/users/languagesAndSkills/actions";
import { LANGUAGES_AND_SKILLS_NAMESPACE } from "@/store/modules/users/languagesAndSkills";
import { isEmpty } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  LANGUAGES_AND_SKILLS_NAMESPACE
);

export default {
  name: "SkillList",
  props: {
    userId: {
      type: String,
      required: true
    },
    showDivider: Boolean
  },
  created() {
    this.fetchUserSkills(this.userId);
  },
  computed: {
    ...mapState(copyState(["isFetchingUserSkills", "currentUserSkills"])),
    isListEmpty() {
      return isEmpty(this.currentUserSkills);
    }
  },
  methods: {
    ...mapActions({
      fetchUserSkills: FETCH_USER_SKILLS
    })
  }
};
</script>
